<template>
  <div id="settingsMain">
    <CoachSettings v-if="user.role_type === 'coach'" />
    <UserSettings v-else-if="user.role_type === 'leader'" />
    <OaSettings v-else-if="user.role_type === 'OA'" />
    <SupportBottom />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SupportBottom from './widgets/SupportBottom.vue';

export default {
  components: {
    SupportBottom,
    CoachSettings: () => import(/* webpackChunkName: "dashboard-coach" */ './CoachSettings.vue'),
  },

  computed: mapState({
    user: (state) => state.user.user,
  }),

  beforeCreate() {
    // Dynamically load components
    if (process.env.VUE_APP_COMPONENT_USER_SETTINGS) {
      this.$options.components.UserSettings = () => import(
        /* webpackChunkName: "custom-leader" */ process.env.VUE_APP_COMPONENT_USER_SETTINGS
      );
    } else {
      this.$options.components.UserSettings = () => import('./UserSettings.vue');
    }

    if (process.env.VUE_APP_COMPONENT_OA_SETTINGS) {
      this.$options.components.OaSettings = () => import(
        /* webpackChunkName: "custom-leader" */ process.env.VUE_APP_COMPONENT_OA_SETTINGS
      );
    } else {
      this.$options.components.OaSettings = () => import('./OaSettings.vue');
    }
  },
};
</script>

<style lang="scss">
  .el-select .el-tag__close.el-icon-close {
    background-color: transparent;
  }
</style>
